<template>
  <div class="modal fade" v-bind:class="modalClass" @click="hideModal($event, true)" ref="modal">
    <div class="modal-dialog">
      <div class="modal-content">
        <!-- Modal Header -->
        <div class="modal-header" v-if="showHeader||showClose">
          <slot name="header">
            <h4 class="modal-title">{{title}}</h4>
          </slot>
          <button type="button" class="close" v-if="showClose" @click="hideModal">&times;</button>
        </div>

        <!-- Modal body -->
        <div class="modal-body">
          <slot></slot>
        </div>

        <!-- Modal footer -->
        <div class="modal-footer" v-if="showFooter">
          <slot name="footer">
            <button
              v-if="showCloseButton"
              type="button"
              class="btn btn-danger"
              @click="hideModal"
            >{{closeButton}}</button>
            <button type="button" class="btn btn-primary" @click="submitModal">{{submitButton}}</button>
          </slot>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
.show {
  display: block;
}
</style>

<script>
export default {
  name: 'w-modal',
  mixins: [],
  props: {
    value: Boolean,
    hideOnOverlay: {
      type: Boolean,
      default: true
    },
    hideOnEsc: {
      type: Boolean,
      default: true
    },
    showHeader: {type: Boolean, default: true},
    showClose: {type: Boolean, default: true},
    showCloseButton: {type: Boolean, default: true},
    showFooter: {type: Boolean, default: true},
    title: {type: String, default: ''},
    size: {type: String, default: '', validator: value => ['', 'default', 'small', 'large'].indexOf(value) >= 0},
    closeButton: {type: String, default: 'Close'},
    submitButton: {type: String, default: 'Ok'},
    closeOnSubmit: {type: Boolean, default: true}
  },
  data() {
    return {
      sid: 'mod' + Math.round(Math.random() * 1000000),
      backdrop: undefined,
      showModal: false
    };
  },
  created() {
    this.showModal = this.value;

    this.backdrop = document.body.querySelector('.modal-backdrop');
    if (!this.backdrop) {
      this.backdrop = this.createBackdrop();
      this.attach(this.backdrop);
    }
  },
  beforeDestroy() {
    if (document.getElementsByClassName('modal').length === 0) {
      this.backdrop.remove();
    } else {
      document.removeEventListener('keyup', this.onKeyPress);
      this.toggleClass(this.backdrop, 'removeClass', 'show');
    }
  },
  mounted() {
    if (this.showModal) {
      this.toggleBodyClass('addClass', 'modal-open');
    }
  },
  computed: {
    modalClass: {
      get() {
        const result = [];
        switch (this.size) {
          case 'large':
            result.push('modal-lg');
            break;
          case 'small':
            result.push('modal-sm');
            break;
        }

        if (this.showModal) {
          result.push('show');
        }
        return result;
      }
    }
  },
  methods: {
    onKeyPress(event) {
      if (event.keyCode === 27) {
        this.hideModal();
      }
    },
    createBackdrop() {
      const backdrop = document.createElement('div');
      backdrop.classList.add('modal-backdrop');
      backdrop.classList.add('fade');
      backdrop.style.display = 'none';
      return backdrop;
    },
    attach(element) {
      document.body.append(element);
    },
    hideModal($event, backdropClick) {
      if (backdropClick && !this.hideOnOverlay) {
        return;
      }
      if (backdropClick && $event.target !== this.$refs.modal) {
        return;
      }

      this.showModal = false;
      this.$emit('close');
    },
    submitModal($event) {
      if (this.closeOnSubmit) {
        this.showModal = false;
      }

      this.$emit('submit');
    },
    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;
      this.toggleClass(el, addRemoveClass, className);
    },
    toggleClass(element, addRemoveClass, className) {
      if (addRemoveClass === 'addClass') {
        element.classList.add(className);
      } else {
        element.classList.remove(className);
      }
    }
  },
  watch: {
    hideOnEsc: {
      handler(next, prev) {
        if (next) {
          document.addEventListener('keyup', this.onKeyPress);
        } else {
          document.removeEventListener('keyup', this.onKeyPress);
        }
      },
      immediate: true
    },
    value(next, prev) {
      this.showModal = next;
    },
    showModal(next, prev) {
      if (next) {
        this.backdrop.style.display = 'block';
        this.toggleBodyClass('addClass', 'modal-open');

        setTimeout(() => {
          this.toggleClass(this.backdrop, 'addClass', 'show');
        }, 100);
      } else {
        this.toggleBodyClass('removeClass', 'modal-open');
        this.backdrop.style.display = 'none';

        setTimeout(() => {
          this.toggleClass(this.backdrop, 'removeClass', 'show');
        }, 100);
      }
    }
  }
};
</script>
